import styled from '@emotion/styled';

import { COLOR_TEXT_PRIMARY } from './utils/variables';

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${COLOR_TEXT_PRIMARY};
`;
